
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import FeaturedProductCard from "./FeaturedProductCard";

interface FeaturedProductsGridProps {
  products: any[];
  onEdit: (product: any) => void;
  onDelete: (id: string) => void;
  onDragEnd: (result: any) => void;
}

const FeaturedProductsGrid = ({ products, onEdit, onDelete, onDragEnd }: FeaturedProductsGridProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="featured-products">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            {products.map((product, index) => (
              <Draggable key={product.id} draggableId={product.id} index={index}>
                {(provided, snapshot) => (
                  <FeaturedProductCard
                    product={product}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    dragHandleProps={provided.dragHandleProps}
                    innerRef={provided.innerRef}
                    isDragging={snapshot.isDragging}
                    {...provided.draggableProps}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default FeaturedProductsGrid;
